@if (item) {
    <vn-menu-item [item]="item" [section]="MenuSection.Footer" linkClass="footer-btn btn" />
}
